import styled from 'styled-components'

interface IAccordionProps {
  expanded: boolean
}

export const Container = styled.div``

export const Header = styled.div`
  display: flex;
  cursor: pointer;
  padding: 12px 0 10px;
  border-bottom: 2px solid ${props => props.theme.colors.color005597};

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }
`

export const Title = styled.div`
  flex-grow: 1;
  font: normal normal bold 16px/20px Inter;
  color: ${props => props.theme.colors.color2d3139};
`

export const ExpandButton = styled.button<IAccordionProps>`
  margin-right: 10px;
  background: transparent;
  border: 0;

  svg {
    stroke: ${props => props.theme.colors.color545e6c};
    stroke-width: 2px;
    height: 10px;
    width: 18px;
    font-weight: bold;
    transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: 0.3s;
  }
`

export const Content = styled.div<IAccordionProps>`
  position: relative;
  height: ${({ expanded }) => (expanded ? '100%' : '0')};

  transition: height 300ms ease-in-out;
  animation: ${({ expanded }) => (expanded ? 'collapse' : 'expand')} 0s ease-in-out;
  overflow: ${({ expanded }) => (expanded ? 'visible' : 'hidden')};

  @keyframes collapse {
    0% {
      max-height: 100%;
      opacity: 1;
    }
    100% {
      max-height: 0px;
      opacity: 0;
    }
  }

  @keyframes expand {
    0% {
      max-height: 0px;
      opacity: 0;
    }
    100% {
      max-height: 100%;
      opacity: 1;
    }
  }
`
